import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveObservationDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.observation.remove ;
}

RemoveObservationDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.observations.url,
    useUrl : true
};

RemoveObservationDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveObservationDialog );
